var config = {};

config.backend = process.env.REACT_APP_BACKEND_URL;
config.website = process.env.REACT_APP_WEBSITE_URL;

config.debug = false;

config.params = {};

config.params.monthNames = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

config.logging = {};
config.logging.severity = process.env.REACT_APP_LOG_SEVERITY || "INFO";
config.logging.label = "Reserve Service";
config.logging.error = "ERROR";

config.start_year = 2018;

module.exports = config;
